<template>
  <v-toolbar-title class="toolbar-title">
    <v-toolbar-side-icon @click.stop="toggleDrawer()" />
    <span v-t="`mainComponent.${currentRoute.name}`" :style="{'text-transform': 'capitalize'}" />
  </v-toolbar-title>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ToolbarTitle',
  computed: {
    ...mapGetters('drawerStore', ['currentRoute']),
  },
  methods: {
    ...mapActions('drawerStore', ['toggleDrawer']),
  },
};
</script>
<style scoped>
.toolbar-title {
  margin-left: 0;
  min-width: 280px;
}
</style>
